const WORK_AS_KEY = 'workAsUser';

export function getCacheKeyPrefix(): string {
  let prefix = '';

  try {
    const workAsUserLocalStorageData = localStorage.getItem(WORK_AS_KEY);
    if (workAsUserLocalStorageData) {
      const workAsUser = JSON.parse(workAsUserLocalStorageData);
      prefix = `${workAsUser.workAsValue}|`;
    }
  } catch (e) {
    // biome-ignore lint/suspicious/noConsole: logging error in console
    console.error(e);
  }

  return prefix;
}
